// Copyright (c) Docugami, Inc. All rights reserved.

import { createSelector, EntityState } from "@reduxjs/toolkit";
import { WorkPathType } from "networking/WorkPathApi";
import { AppState } from "store";
import { WorkPath } from "networking/WorkPathApi";
import { selectGetWorkPaths, workPathsAdapter } from "./workPathSlice";

export const selectWorkPaths = createSelector(
    (state: AppState) => selectGetWorkPaths(state),
    (state: AppState, docsetId?: string, types?: WorkPathType[]) => docsetId,
    (state: AppState, docsetId?: string, types?: WorkPathType[]) => types,
    (workPaths, docsetId, types): EntityState<WorkPath> => {
        if (!workPaths?.ids.length) {
            return workPathsAdapter.getInitialState();
        }

        if (!docsetId && !types?.length) {
            return workPaths;
        }

        const removedIds = workPaths.ids.filter(id => {
            const workPath = workPaths.entities[id]!;
            return (docsetId !== undefined && workPath.clusterId !== docsetId) ||
                (!!types?.length && !types.includes(workPath.workPathType))
        })

        return workPathsAdapter.removeMany(workPaths, removedIds);
    }
);